var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSupport = function SvgSupport(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 88 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.47,47.52c2.31,2,2.52,3.07,5.88,3.07,1.62,0,5.71-.53,6.88-1.58A4.78,4.78,0,0,0,18,45.28V26.73A4.81,4.81,0,0,0,16.23,23c-1.18-1-5.26-1.57-6.88-1.57-3.36,0-3.57,1-5.88,3.07A9.68,9.68,0,0,0,0,32V40A9.68,9.68,0,0,0,3.47,47.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,50.59h2.89c1.47-.35,1.58-1.48,3.38-3.06A9.71,9.71,0,0,0,87.71,40V32a9.71,9.71,0,0,0-3.47-7.53c-2.31-2.05-1.6-3.07-5-3.07-1.63,0-5.71.53-6.89,1.57a4.88,4.88,0,0,0-1.78,3.73V45.3a4.37,4.37,0,0,0,2.55,4.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3,5.14a31.5,31.5,0,0,0-13.67,3,25.47,25.47,0,0,0-10,8.15A18.83,18.83,0,0,0,18,27.43v1.72a1.51,1.51,0,0,1-.59,1.23,2.21,2.21,0,0,1-1.5.48H13.76a2.24,2.24,0,0,1-1.51-.48,1.51,1.51,0,0,1-.59-1.23V27.43a24.42,24.42,0,0,1,4.79-13.61,31.71,31.71,0,0,1,11.89-10A37.59,37.59,0,0,1,45.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.39,0a37.46,37.46,0,0,1,17,3.86,31.52,31.52,0,0,1,11.88,10A24.43,24.43,0,0,1,77,27.44v1.71a1.52,1.52,0,0,1-.59,1.24,2.29,2.29,0,0,1-1.51.47H72.82a2.22,2.22,0,0,1-1.51-.48,1.49,1.49,0,0,1-.6-1.23V27.43A18.7,18.7,0,0,0,67,16.29,25.33,25.33,0,0,0,57,8.14a31.38,31.38,0,0,0-13.65-3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.29,
    cy: 72.08,
    rx: 9.41,
    ry: 6.54,
    transform: "translate(-33.47 65.86) rotate(-46.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.81,66.65l-3-2L79.18,46l2.56,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.51,35.29c0,9.63-9.72,27.11-20.05,27.11-10,0-20-17.48-20-27.11s9-19.89,20.05-19.89S64.51,25.67,64.51,35.29Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSupport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Support.d9b270646f964c55b07862f919dfc9a4.svg";